export default __webpack_public_path__ + "static/media/bag3.14ee0fcc.png";